import React from "react"
import "./InitPlaceholder.scss"

const InitPlaceholder: React.FC = () => {
  return <div className="neo__initPlaceholder" data-testid="init-placeholder"><div /></div>
}

export default InitPlaceholder
